import { render, staticRenderFns } from "./StepViewCreateOrederIndustry.vue?vue&type=template&id=0cba66a0"
import script from "./StepViewCreateOrederIndustry.vue?vue&type=script&lang=js"
export * from "./StepViewCreateOrederIndustry.vue?vue&type=script&lang=js"
import style0 from "./StepViewCreateOrederIndustry.vue?vue&type=style&index=0&id=0cba66a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports